import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Release } from '../models/release.model';
import { GatewayApi } from './gateway.api';

@Injectable()
export class ReleaseService extends GatewayApi<Release> {
  constructor(
    http: HttpClient,
    private auth: RoleService,
    uxService: UxService
  ) {
    super('releases', http, auth, uxService);
  }
}
